import { Table, Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import React from 'react';

import { info_circle } from '../../../../assets/img';
import TalentFinderPagination from '../../../TalentFinderPage/TalentFinderDetail/Pagination/TalentFinderPagination';
import styles from './position-finder-list.module.scss';

const columns = [
  {
    title: 'No.',
    dataIndex: 'key',
  },
  {
    title: 'Position Title',
    dataIndex: 'position_name',
    width: 170,
  },
  {
    title: 'Business',
    dataIndex: 'business',
  },
  {
    title: 'Sector',
    dataIndex: 'sector',
  },
  {
    title: 'OPU',
    dataIndex: 'opu',
  },
  {
    title: 'Division',
    dataIndex: 'division',
  },
  {
    title: 'Department',
    dataIndex: 'department',
  },
  {
    title: 'Job Grade',
    dataIndex: 'job_grade',
    width: 125,
  },
  {
    title: 'Job Function',
    dataIndex: 'job_function',
    width: 125,
  },
  {
    title: 'SKG',
    dataIndex: 'skg',
  },
  {
    title: 'Current Incumbent',
    dataIndex: 'current_incumbent',
    width: 170,
  },
];
const TalentFinderList = (props) => {
  const { page, toResults, limit, fromResult, totalResult, data, onPageChange } = props;

  const handleRenderPagination = () => (
    <>
      {!isEmpty(data) && (
        <TalentFinderPagination
          currentPage={page}
          totalResult={totalResult}
          limit={limit}
          startRecordNumber={fromResult}
          endRecordNumber={toResults > totalResult ? totalResult : toResults}
          onPageChange={onPageChange}
        />
      )}
    </>
  );

  return (
    <div className={styles.detail_list_section} data-testid="talent-finder-list">
      <Table
        columns={columns}
        dataSource={data.map((d) => {
          return {
            ...d,
            position_name: (
              <div onClick={() => window.open('/position-finder/' + d.position_code, '_blank')} style={{ cursor: 'pointer' }}>
                <div className={styles.table_name} style={{ marginBottom: '5px' }}>
                  {d.position_name}
                </div>
                <div className={styles.table_except_name}>{d.position_code}</div>
              </div>
            ),
            business: <div className={styles.table_except_name}>{d.business}</div>,
            sector: <div className={styles.table_except_name}>{d.sector}</div>,
            opu: <div className={styles.table_except_name}>{d.opu}</div>,
            division: <div className={styles.table_except_name}>{d.division}</div>,
            department: <div className={styles.table_except_name}>{d.department}</div>,
            job_grade: <div className={styles.table_except_name}>{d.job_grade}</div>,
            job_function: <div className={styles.table_except_name}>{d.job_function}</div>,
            skg: (
              <div>
                <div className={styles.table_except_name} style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '10px' }}>{d.skg}</span>
                  <Tooltip title={d.skg_text} overlayClassName={styles.tooltip}>
                    <img src={info_circle} alt="info_circle" />
                  </Tooltip>
                </div>
              </div>
            ),
            current_incumbent: (
              <div
                onClick={() =>
                  d.current_incumbent !== '-' || d.current_incumbent_code ? window.open('/profile/' + d.current_incumbent_code, '_blank') : undefined
                }
                style={{ cursor: 'pointer' }}
              >
                <div className={styles.table_name}>{d.current_incumbent}</div>
                <div className={styles.table_except_name}>{d.current_incumbent_code}</div>
              </div>
            ),
          };
        })}
        className={styles.detail_list_table}
        pagination={false}
        footer={handleRenderPagination}
      />
    </div>
  );
};

export default TalentFinderList;
